import { ColumnType } from '@dynamika-shared/ui/Table/Table.types';
import { SiteSubjectType } from '@dynamika-shared/types/subjects';
import { format, parse } from 'date-fns';
import { UploadIcon } from '@dynamika-shared/ui/icons';
import React from 'react';
import { TruncatedText } from '@dynamika-shared/ui/TruncatedText/TruncatedText';
import { CohortType } from '@dynamika-shared/types/cohorts';

export function makeSubjectListColumns(
  setSubject: (T: SiteSubjectType) => void,
  cohorts: CohortType[]
): ColumnType<SiteSubjectType>[] {
  return [
    {
      name: 'code',
      tdClassName: 'w-[210px]',
      header() {
        return 'Subject ID';
      },

      loading: () => (
        <div className='h-2 w-10 animate-pulse rounded-md bg-slate-300'></div>
      ),
      getValue(row) {
        return <TruncatedText text={row.code} truncate tooltip />;
      },
    },
    {
      name: 'birthDate',
      tdClassName: 'w-[190px]',
      header() {
        return 'Date of Birth';
      },
      loading: () => (
        <div className='h-2 w-10 animate-pulse rounded-md bg-slate-300'></div>
      ),
      getValue(row) {
        const formattedDate = parse(
          row.dob.replace('.', '-'),
          'MM-yyyy',
          new Date()
        );
        return format(formattedDate, 'MMM-yyyy');
      },
    },
    {
      name: 'cohort',
      tdClassName: 'w-[210px]',
      header() {
        return 'Cohort';
      },

      loading: () => (
        <div className='h-2 w-10 animate-pulse rounded-md bg-slate-300'></div>
      ),
      getValue(row) {
        const cohort = cohorts?.find(cohort => cohort?.id === row?.cohortId);

        return <div className=''>{cohort?.name}</div>;
      },
    },
    {
      name: 'lastUploadedVisitDefId',
      hasSorting: true,
      header() {
        return <p className='flex items-center'>Last Uploaded Visit</p>;
      },
      loading: () => (
        <div className='h-2 w-10 animate-pulse rounded-md bg-slate-300'></div>
      ),
      getValue(row) {
        const lastVisit = row.lastVisit;
        const isUnscheduled =
          lastVisit?.type === 'UNSCHEDULED' && !lastVisit?.earlyTermination;
        const visitName = isUnscheduled ? (
          <div>
            <div>Unscheduled</div>
            <div>
              {format(
                new Date((lastVisit?.latestUpload || lastVisit?.name) ?? '-'),
                'dd-MMM-yyy'
              )}
            </div>
          </div>
        ) : (
          lastVisit?.name ?? '-'
        );
        return <div className=''>{visitName}</div>;
      },
    },
    {
      name: 'action',
      alignToRight: true,
      header() {
        return 'Action';
      },
      loading: () => (
        <div className='h-2 w-10 animate-pulse rounded-md bg-slate-300'></div>
      ),
      getValue(row: SiteSubjectType) {
        return (
          <UploadIcon
            onClick={() => {
              setSubject(row);
            }}
            className='mr-1.5 h-2  w-2 text-spanishGray hover:text-dodgerBlue'
          />
        );
      },
    },
  ];
}
